import { Link } from 'react-router-dom';
import { Loader } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledTableWrapper = styled.div`
position: relative;
.visible.transition {
    display: table !important;
  }
.sortable {
  cursor: pointer;
  &:hover {
    opacity: 0.8;
    background-color: ${props => props.theme?.secondColor} !important;
  }
}
 .ui.ribbon.label {
  width: 120px;
  max-width 120px;
 }
`
export const StyledNoResultsMessage = styled.div`
display: flex;
justify-content: center;
.ui.placeholder.segment {
  width: 200px;
  min-height: 200px;
  border-radius: 50%;
  .header {
    margin-right: unset !important
   }
}  
`
export const StyledActionLoader = styled(Loader)`
margin: 5px !important;
position: inherit !important;
width: 1.5em !important;
height: 1.5em !important;
top: 0 !important; 
left: 0 !important; 
`
export const StyledLoaderWrapper = styled.div`
position: relative;
.ui.loader:before, .ui.loader:after {
 width: 1.8em !important;
 height: 1.8em !important;
 margin: 0 0 0 -1.14285714rem ;
 margin-top: 13px !important;
 margin-left: -8px !important;
}
`
export const StyledLink = styled(Link)`
color: #4183c4 !important;
`